import { listTriggers as publicListTriggers } from './ecom-custom-trigger-v1-custom-trigger-discounts-custom-trigger.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
export const listTriggers = /*#__PURE__*/ createRESTModule(publicListTriggers);
//# sourceMappingURL=ecom-custom-trigger-v1-custom-trigger-discounts-custom-trigger.context.js.map